import { render, staticRenderFns } from "./prpItems.vue?vue&type=template&id=15bf40da"
import script from "./prpItems.vue?vue&type=script&lang=js"
export * from "./prpItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports